var map = {
	"./bg.jpg": "29a8",
	"./bg1.jpg": "4638",
	"./card1.png": "50e3",
	"./card2.png": "fe61",
	"./code.png": "cc8c",
	"./code1.jpg": "e7c1",
	"./gift.png": "edd0",
	"./logo.png": "f30c",
	"./logo1.jpg": "f331",
	"./logo1.png": "bef2",
	"./logo2.jpg": "11f2",
	"./logo_transparent.png": "947e",
	"./person.png": "962a",
	"./write.png": "9b9f",
	"./图片2.png": "3a18"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ee2";